// extracted by mini-css-extract-plugin
export default {"hotelAndRoomAllocation":"styles_hotelAndRoomAllocation__IvCbz","formItem":"styles_formItem__kLwKk","formItemCol":"styles_formItemCol__rwU6m"};